import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

import OrderHead from "@/shared/model/orderHead";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import DeliveryCardHeadComponent from "@/modules/Store/components/DeliveryCardHeadComponent.vue";
import OrderItem from "@/shared/model/orderItem";
import DeliveryCardItemComponent from "@/modules/Store/components/DeliveryCardItemComponent.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";

interface Props {
  orderHead:OrderHead
  orderItems: OrderItem[]
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'DeliveryCardComponent',
  props: {
    orderHead: { default: undefined },
    orderItems: {}
  },
  setup(__props: any) {


const props = __props





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardTitle, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.orderHead.orderNumber), 1)
        ]),
        _: 1
      }),
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createVNode(SogFlexRow, { class: "test" }, {
            default: _withCtx(() => [
              _createVNode(DeliveryCardHeadComponent, {
                "order-head": props.orderHead
              }, null, 8, ["order-head"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orderItems, (item) => {
                return (_openBlock(), _createBlock(DeliveryCardItemComponent, {
                  key: item,
                  item: item
                }, null, 8, ["item"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})